import { client } from "@/store/client.js";
import axios from "axios";

export const namespaced = true;

export const state = {	
	plans: [
        {
            id: 1,
            name: 'DESER Betriebstagebuch',
            description: "Erhalten Sie den vollen Zugang zum Betriebstagebuch für 1 Monat. Dieses Abonnement wird monatlich abgebucht.",
            price: '30.00',
            currency: '€',            
            list: [
                "Alle mit VN erfassten Fahrzeuge können ins BTB überführt werden",
                "einfache Erfassung von Fraktionsausgängen",
                "jederzeit aktuelle Übersicht über den Fraktionsbestand",
                "jederzeit aktuelle Recyclingquote überwachen",
                "Eigenverbrauch und Korrekturen",
                "einfache Erfassung von verkauften Teilen",
                "übersichtlicher Ausdruck für die Zertifizierung",
                "Verwalten der Mitarbeiterqualifikationen und Nachschulungen",
                "einfache Tagebuchfunktion für Vorfälle"
            ],
        },
        {
            id: 2,
            name: 'Verwertungsnachweis freischalten',
            description: "Gerne schalten wir Ihnen, ihren Verwertungsnachweis wieder frei. Dieser Service ist kostenpflichtig.",
            price: '5.00',
            mollieprice: '420',
            currency: '€'
        }
    ]
}

export const actions = {
    preparePayment({commit}, payment) {
        return client.coreapi.post('/subscribe', payment)
        .then(( r ) => {
            return r.data
        })
    },
    prepareOnePayment({commit}, payment) {
        return client.coreapi.post('/mollie-payment', payment)
        .then(( r ) => {
            return r.data
        })
    },
    getPaymentInfo({commit}, payment) {
        return client.coreapi.post('/getcorepaymentinfo', payment)
        .then(( r ) => {           
            return r.data
        })
    },
    validateCoupon({commit}, coupon) {
        return client.coreapi.get('/validate/' + coupon)
        .then(( r ) => {
            return r.data
        })
    },
    getReceptionData({commit}, receptionId) {
        return client.core.get('/receptions/' + receptionId).then(( r ) => {
            return r.data
        })
    }
}